import React, { useEffect, useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Services',
    href: '#services'
  }, {
    name: 'Service Areas',
    href: '#areas'
  }, {
    name: 'Why Us',
    href: '#why-us'
  }];
  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      const offset = 80; // Header height
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
    setIsMobileMenuOpen(false);
  };
  return <header className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-md shadow-md py-2' : 'bg-transparent py-4'}`} data-id="element-86">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-87">
        <div className="flex justify-between items-center" data-id="element-88">
          {/* Logo */}
          <a href="#" className="flex items-center z-50" onClick={e => {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        }} data-id="element-89">
            <img src="https://cdn.magicpatterns.com/uploads/vUDtTmdUZMNagQvXEMztF5/FEBFB789-B4DB-40E8-BB0A-4BC650B55AAD.png" alt="Pancho's Lawn Care Logo" className={`transition-all duration-300 ${isScrolled ? 'h-12' : 'h-16 lg:h-20'}`} data-id="element-90" />
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center space-x-8" data-id="element-91">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={e => scrollToSection(e, link.href)} className={`text-sm font-semibold tracking-wide transition-colors ${isScrolled ? 'text-gray-700 hover:text-forest-700' : 'text-white hover:text-cream-200 drop-shadow-md'}`} data-id="element-92">
                {link.name}
              </a>)}
            <a href="tel:8153540484" className="flex items-center gap-2 bg-forest-700 hover:bg-forest-900 text-white px-5 py-2.5 rounded-full font-medium transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-0.5" data-id="element-93">
              <Phone size={18} data-id="element-94" />
              <span data-id="element-95">(815) 354-0484</span>
            </a>
          </nav>

          {/* Mobile Menu Toggle */}
          <button className="md:hidden z-50 p-2 rounded-md" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-96">
            {isMobileMenuOpen ? <X className={isScrolled || isMobileMenuOpen ? 'text-forest-900' : 'text-white'} size={28} data-id="element-97" /> : <Menu className={isScrolled ? 'text-forest-900' : 'text-white'} size={28} data-id="element-98" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav Overlay */}
      <AnimatePresence data-id="element-99">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} className="absolute top-full left-0 right-0 bg-white shadow-xl border-t border-gray-100 md:hidden" data-id="element-100">
            <div className="flex flex-col px-4 py-6 space-y-4" data-id="element-101">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={e => scrollToSection(e, link.href)} className="text-lg font-medium text-gray-800 p-2 hover:bg-cream-100 rounded-lg transition-colors" data-id="element-102">
                  {link.name}
                </a>)}
              <div className="pt-4 border-t border-gray-100" data-id="element-103">
                <a href="tel:8153540484" className="flex items-center justify-center gap-2 bg-forest-700 text-white p-3 rounded-lg font-medium w-full" data-id="element-104">
                  <Phone size={20} data-id="element-105" />
                  <span data-id="element-106">Call (815) 354-0484</span>
                </a>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}